import Panel from 'portaltransparencia-common/components/Panel.react.js';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import TableHeaderItem from 'portaltransparencia-common/components/TableHeaderItem.react';
import {
  addFilterUrl,
  addPagination
} from 'portaltransparencia-common/libs/AddFilter.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';
import * as actions from './Actions.js';

export class CargoServidores extends Component {
  static propTypes = {
    cargoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    page: PropTypes.object.isRequired,
    findServidoresCargo: PropTypes.func.isRequired,
    limparServidoresCargo: PropTypes.func.isRequired
  };

  state = {
    collapsed: true,
    carregado: false
  };

  componentDidMount() {
    this.props.limparServidoresCargo();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.cargoId !== this.props.cargoId) {
      this.props.limparServidoresCargo();
      this.setState({ collapsed: true, carregado: false });
    }
  }

  onClickPanel = collapsed => {
    const { page } = this.props;
    const primeiraExpansao = !collapsed && !this.state.carregado;

    this.setState({ collapsed });

    if (primeiraExpansao) {
      this.setState({ carregado: true });
      this.searchWithPage(page.set('number', 0));
    }
  };

  searchWithPage = page => {
    const { cargoId, findServidoresCargo } = this.props;

    findServidoresCargo(
      addPagination(page, addFilterUrl('', `cargoId=${cargoId}`))
    );
  };

  renderServidor = (servidor, index) => (
    <tr key={`${servidor.get('matricula')}_${index}`}>
      <td>{servidor.get('matricula')}</td>
      <td>{servidor.get('nome')}</td>
      <td>{DateUtils.formatDateTimeShort(servidor.get('dataAdmissao'))}</td>
      <td>{servidor.get('faixaDescricao')}</td>
    </tr>
  );

  render() {
    const { page } = this.props;
    const content = page.get('content');

    return (
      <Panel
        title="Servidores"
        collapsed={this.state.collapsed}
        onClickPanel={this.onClickPanel}
        mobileClose
        tableResponsive
      >
        <div className="panel-table-outer">
          <table className="panel-table striped fancy">
            <TableHeader
              empty={!content || content.isEmpty()}
              text="Sem registros"
            >
              <tr>
                <TableHeaderItem
                  field="matricula"
                  label="Matrícula"
                  page={page}
                  searchWithPage={this.searchWithPage}
                />
                <TableHeaderItem
                  field="nome"
                  label="Nome"
                  page={page}
                  searchWithPage={this.searchWithPage}
                />
                <TableHeaderItem
                  field="dataAdmissao"
                  label="Data de Admissão"
                  page={page}
                  searchWithPage={this.searchWithPage}
                />
                <TableHeaderItem
                  field="faixaDescricao"
                  label="Faixa Salarial"
                  page={page}
                  searchWithPage={this.searchWithPage}
                />
              </tr>
            </TableHeader>
            <tbody>{content && content.map(this.renderServidor)}</tbody>
          </table>
        </div>
        <SearchPagination page={page} searchWithPage={this.searchWithPage} />
      </Panel>
    );
  }
}

function mapStateToProps(state) {
  return {
    page: state.cargo.get('servidoresCargo')
  };
}

export default connect(mapStateToProps, actions)(CargoServidores);
